import { enumSchema } from "vue-utils"

export enum MarriagePerson {
	Me = "Me",
	Partner = "Partner",
}

export const MarriagePersonSchema = enumSchema(MarriagePerson)
